import { Auth as SupabaseAuth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { supabase } from '../lib/supabase';

export const Auth = () => {
  return (
    <div className="min-h-screen bg-[#0d0d14] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <h1 className="text-4xl font-bold cyberpunk-title text-[#00fff9] mb-2">RPG Task Manager</h1>
          <p className="text-gray-400">Level up your productivity</p>
        </div>
        <div className="cyberpunk-card rounded-lg p-6 neon-border">
          <SupabaseAuth
            supabaseClient={supabase}
            appearance={{
              theme: ThemeSupa,
              style: {
                button: { background: '#00fff9', color: '#0d0d14' },
                anchor: { color: '#00fff9' },
                input: { background: '#0d0d14', borderColor: '#00fff933' }
              },
              variables: {
                default: {
                  colors: {
                    brand: '#00fff9',
                    brandAccent: '#ff00c1',
                    inputBackground: '#0d0d14',
                    inputText: '#ffffff',
                    inputBorder: '#00fff933',
                    inputBorderFocus: '#00fff9',
                    inputBorderHover: '#00fff966',
                  },
                },
              },
            }}
            providers={[]}
            redirectTo={window.location.origin}
          />
        </div>
      </div>
    </div>
  );
};